import { TripEventType } from 'app/constants/delegation/tripEventType'

export const getEventType = (type: number): TripEventType => {
  let eventType = TripEventType.Begin

  switch (type) {
    case 2:
      eventType = TripEventType.Finish
      break
    case 3:
      eventType = TripEventType.ChangeCountry
      break
    case 4:
      eventType = TripEventType.TripExclusionStart
      break
    case 5:
      eventType = TripEventType.TripExclusionEnd
      break
    case 6:
      eventType = TripEventType.Arrive
      break
    case 7:
      eventType = TripEventType.Leave
      break
    case 8:
      eventType = TripEventType.Loading
      break
    case 9:
      eventType = TripEventType.Unloading
      break
  }

  return eventType
}
